/**
 * Brand identity for the Spatial kitchen template.
 *
 * <p><strong>The shop is Spatial Studio.</strong> "The Kitchen Shop" is one of
 * its mottos and belongs under the name (`brand.tagline`), never in its place —
 * the owner has had to correct that twice. The name lives in exactly two
 * places, which must be changed together:
 * <ol>
 *   <li>{@link BRAND_NAME} below: the fallback the chrome renders when the shell
 *       carries no brand name;</li>
 *   <li>`seedShellFills.chrome[0].props.brand.name` in
 *       `templates/seed-data/templates/spatial-kitchen.json`: what the storefront
 *       actually renders once the template is applied.</li>
 * </ol>
 * No block copy repeats the name; the footer builds its copyright line from it.
 */
export const BRAND_NAME = 'Spatial Studio';

/** The line under the name in the header, when the shell carries no `brand.tagline`. */
export const BRAND_MOTTO = 'The Kitchen Shop';

/** Theme id: the key the storefront registry, the template and `themes.json` share. */
export const THEME_ID = 'spatial-kitchen';

/** Template key used by `seeds:push` (`TEMPLATE_KEY=spatial-kitchen`). */
export const TEMPLATE_KEY = 'spatial-kitchen';

/**
 * The online planner is a separate static app served at `/kitchens/planner/` (PLAN.md,
 * Contract 4). Links to it must be plain anchors, never client-side Next
 * navigation, because the storefront does not own that route.
 */
export const PLANNER_HREF = '/kitchens/planner/';
